import { render } from "./TrustSection.vue?vue&type=template&id=54f5fcf2&scoped=true"
import script from "./TrustSection.vue?vue&type=script&lang=js"
export * from "./TrustSection.vue?vue&type=script&lang=js"

import "./TrustSection.vue?vue&type=style&index=0&id=54f5fcf2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f5fcf2"]])

export default __exports__